import axios, { AxiosRequestConfig } from "axios";

const createAxiosInstance = (
	customHeaders: AxiosRequestConfig["headers"] = {}
) => {
	const token = localStorage.getItem("token");
	const defaultHeaders: any = {};

	if (token) {
		defaultHeaders.Authorization = `Bearer ${token}`;
	}

	const headers = { ...defaultHeaders, ...customHeaders };

	return axios.create({
		baseURL:
			process.env.REACT_APP_SERVER_URL || "https://chat.1ciso.io/backend",
		headers,
	});
};

export default createAxiosInstance;